import { render, staticRenderFns } from "./AddActions.vue?vue&type=template&id=63c57d5d&scoped=true&"
import script from "./AddActions.vue?vue&type=script&lang=js&"
export * from "./AddActions.vue?vue&type=script&lang=js&"
import style0 from "./AddActions.vue?vue&type=style&index=0&id=63c57d5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c57d5d",
  null
  
)

export default component.exports